module.exports = __webpack_public_path__ + "static/media/37.701b0cbc.png";